import { generateShopAssociatedKey } from "#/utils/keyHandler"

//
const shopProductListKey = "yingqiyu_ziubao_shop_product_list";
const shopProductListShopIdKey = "yingqiyu_ziubao_shop_product_list_shop_id";

export const setShopProductList = (shopId, shopProduct) => {
    /**
     * 
     */
    let shopProductListShopId = localStorage.getItem(shopProductListShopIdKey);
    
    if (shopProductListShopId != null)
    {
        clearShopProductList(shopProductListShopId);
    }
    
    localStorage.setItem(shopProductListShopIdKey, shopId)

    /**
     * 
     */
    localStorage.setItem(generateShopAssociatedKey(shopId, shopProductListKey), shopProduct);
}

export const getShopProductList = (shopId) => {
    let shopProductString = localStorage.getItem(generateShopAssociatedKey(shopId, shopProductListKey));

    if (shopProductString) {
        return JSON.parse(shopProductString);
    }

    return [];
}

export const clearShopProductList = (shopId) => {
    localStorage.removeItem(generateShopAssociatedKey(shopId, shopProductListKey));
}

//
const shopStateKey = "yingqiyu_ziubao_shop_state";
const shopStateShopIdKey = "yingqiyu_ziubao_shop_state_shop_id";

export const setShopState = (shopId, shopState) => {
    /**
     * 
     */
    let shopStateShopId = localStorage.getItem(shopStateShopIdKey);

    if (shopStateShopId != null) {
        clearShopState(shopStateShopId);
    }

    localStorage.setItem(shopStateShopIdKey, shopId)

    /**
     * 
     */
    localStorage.setItem(generateShopAssociatedKey(shopId, shopStateKey), JSON.stringify(shopState));
}

export const getShopState = (shopId) => {
    let shopProductString = localStorage.getItem(generateShopAssociatedKey(shopId, shopStateKey));

    if (shopProductString) {
        return JSON.parse(shopProductString);
    }

    return {
        ifShowTop: true,
        ifShowAllProductList: true,
        activeProductTypeIndex: 0,
        productListWithTagAll: [], 
        scrollTop: 0,
    };
}

export const clearShopState = (shopId) => {
    localStorage.removeItem(generateShopAssociatedKey(shopId, shopStateKey));
}